import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
    list: [],
};

// ==============================|| SLICE - PAGESS_SEE ||============================== //

const pagesSse = createSlice({
    name: 'pagesSse',
    initialState,
    reducers: {
        saveSse(state, action) {
            state[action.payload[0]] = {
                ...state[action.payload[0]],
                [action.payload[1]]: action.payload[2],
            };
        },

        setSse(state, action) {
            state[action.payload[0]] = {
                ...state[action.payload[0]],
                [action.payload[1]]: action.payload[2],
            };
        },
        clearSse(state, action) {
            state[action.payload[0]] = {};
        },
        removeSse(state, action) {
            const { name: slice, data } = action.payload;
            state[slice] = state[slice].filter(
                item => !data.includes(item.uuid),
            );
            state.index = data.reduce((index, uuid) => {
                if (uuid in index) {
                    // eslint-disable-next-line no-unused-vars
                    const { [uuid]: _, ...restIndex } = index;
                    return restIndex;
                }
                return index;
            }, {});
        },
    },
});

export default pagesSse.reducer;

export const { setSse, removeSee, saveSee, clearSee } = pagesSse.actions;
